import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const CreditCardBills = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Credit Card Bills</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">Credit card bills component will be implemented here.</p>
          <p className="text-sm text-gray-500 mt-2">This will include credit card bill tracking and payment management.</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CreditCardBills;
